import React from "../_snowpack/pkg/react.js";
export const Intro = () => {
  return /* @__PURE__ */ React.createElement("div", {
    className: "content"
  }, /* @__PURE__ */ React.createElement("h2", null, "About"), /* @__PURE__ */ React.createElement("p", null, "A css houdini paintWorklet to create these beveled borders in CSS. See ", /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("a", {
    href: "https://github.com/w3c/css-houdini-drafts/blob/main/css-paint-api/EXPLAINER.md",
    target: "_blank"
  }, "https://github.com/w3c/css-houdini-drafts/blob/main/css-paint-api/EXPLAINER.md"), " ", /* @__PURE__ */ React.createElement("br", null), "for mor details on Houdinis css-paint-api."), /* @__PURE__ */ React.createElement("p", null, "For supported Browsers check: ", /* @__PURE__ */ React.createElement("a", {
    href: "https://ishoudinireadyyet.com/",
    target: "_blank"
  }, "https://ishoudinireadyyet.com/"), "A Polyfill for Firefox exists, but is slow and somewhat unreliable."));
};
